
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MeltingReturnItemsGrid extends Serenity.EntityGrid<MeltingReturnItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MeltingReturnItems'; }
        protected getDialogType() { return MeltingReturnItemsDialog; }
        protected getIdProperty() { return MeltingReturnItemsRow.idProperty; }
        protected getInsertPermission() { return MeltingReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MeltingReturnItemsRow.localTextPrefix; }
        protected getService() { return MeltingReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}